import type { Slide } from '@features/powerpoint';
import type { BuildPresentationProps } from '../build-presentation';
import { overviewSlideInterfaceV2 } from '../../../../slides/overview-slide-interface-v2';
import { formatters } from '@utils/formattersV2';

const valueIfPresent = (value: string | undefined) =>
  value && value.length > 0 ? value : null;

export const overviewSlideFromPropsV2 = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] => {
  return props.customFields.includedSlides.overall.overview
    ? [
        overviewSlideInterfaceV2({
          flightDates: [props.campaign.startDate, props.campaign.endDate],
          measurementDates: [
            props.campaign.startDate,
            props.selectedReportDate,
          ],
          metrics: [
            {
              name: 'Impressions',
              value: formatters.number(props.report.impressions, {
                full: true,
              }),
            },
            {
              name: 'Users Matched for Attribution',
              value: formatters.number(props.report.matchedForAttribution, {
                full: true,
              }),
            },
            {
              name: 'Unique Users',
              value: formatters.number(props.report.uniqueUsers, {
                full: true,
              }),
            },
            {
              name: 'Media Spend',
              value: formatters.currency(props.calculatedFields.adSpend ?? 0, {
                full: true,
                decimals: 0,
              }),
            },
          ],
          reportsIncluded: [
            ...(props.report.hasVisitMetrics ? ['Foot Traffic Lift'] : []),
            'Sales Lift',
          ],
          reportingDimensions: props.report.dimensions.map(dim => {
            const dimension = (
              props.customFields.dimensions as Record<
                string,
                BuildPresentationProps['customFields']['dimensions']['ds']
              >
            )[dim.dimensionName];
            return (
              valueIfPresent(dimension?.salesTableHeader) ??
              valueIfPresent(dimension?.visitsTableHeader) ??
              dim.dimensionName
            );
          }),
          slideMaster,
        }),
      ]
    : [];
};
